import script from "./AnnouncementAndAirdrops.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementAndAirdrops.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementAndAirdrops.vue?vue&type=style&index=0&id=0f7a354a&lang=scss&scoped=true"
script.__scopeId = "data-v-0f7a354a"

export default script